module.exports = __webpack_public_path__ + "static/media/02.efab5491.jpg";